import { ROUTES, useNotificationStore, CMSNotification, formatDateDots, registerEntityEndpoint } from "@editor/ui-utils";
import { QImg, QBtn, QTooltip, QPageContainer, QPage } from "quasar";
import { defineComponent, ref, onBeforeMount, watch, computed, createElementBlock, openBlock, createCommentVNode, createElementVNode, createVNode, normalizeClass, createBlock, withCtx, createTextVNode, toDisplayString, createStaticVNode, Fragment, renderList, renderSlot } from "vue";
import { getEmptyCtaButton, getCtaButton } from "@modules/cta-button-editor-ui";
import { getImage, getImageUrl, prefillEditorImage } from "@modules/image-editor-ui";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { SocialLinkUtils } from "@utils/string-utils";
const de = {
  assemblerApi: {
    createAlreadyExists: "Assembler kann nicht erstellt werden, da bereits ein Assembler mit diesem Namen existiert",
    updateAlreadyExists: "Assembler kann nicht aktualisiert werden, da bereits ein Assembler mit diesem Namen existiert",
    created: "Assembler erstellt",
    updated: "Assembler aktualisiert",
    notFound: "Assembler nicht gefunden",
    requiredFields: "Sie können den Assembler nicht speichern, da obligatorische Informationen fehlen"
  },
  assemblerList: {
    title: "Inhaltsfreigabe",
    newButton: "Neues Assembler",
    searchLabel: "Nach Hauptzeile oder Vorspann suchen",
    deleteAssembler: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Assembler",
    headerTeaser: "Artikelbild",
    headerSummary: "Artikelübersicht",
    headerBrands: "Veröffentlicht auf",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Assembler Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createAssembler: "Assembler erstellen",
    partner: "Partner",
    partnerMissing: "Partner fehlt",
    partnerExpired: "Verfallen",
    fixum: "Fixum",
    revShare: "Revenue Share",
    layout: {
      table: "Tabelle",
      grid: "Raster",
      list: "Liste"
    },
    automaticPollingOn: "Wir prüfen automatisch alle {interval} Sekunden, ob neue Artikel verfügbar sind. Tippen Sie hier, um sofort nach neuen Artikeln zu suchen.",
    automaticPollingOff: "Wir suchen derzeit nicht nach neuen Artikeln. Tippen Sie hier, um die Funktion zu aktivieren.",
    newBreakingNewsArticle: "Ein neuer Eilmeldungsartikel ist eingetroffen!",
    openPreview: "Artikelvorschau öffnen",
    visibilitySettings: {
      actions: "Aktionen",
      brands: "Marken",
      categories: "Kategorien",
      date: "Datum",
      partner: "Partner",
      leadtext: "Vorspann",
      tags: "Tags (Eilmeldung, Dringlichkeit usw.)",
      teaser: "Teaser-Bild"
    }
  },
  assembler: {
    assemblerLabel: "Assembler",
    backButton: "Zurück zur Assembler-Liste",
    newAssembler: "Neues Assembler",
    messageDeleteAssembler: "Assembler löschen",
    messageDeleteAssemblerTitle: "Sind Sie sicher, dass Sie dieses Assembler löschen möchten?",
    deleteAssembler: "Löschen",
    messageDeleted: "Assembler gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Assemblers",
    errorFailedLoadedAssemblerWithId: "Es gab einen Fehler beim Abrufen des Assemblers",
    dropdownEdit: "Artikel bearbeiten",
    dropdownImport: "Artikel importieren",
    dropdownImportEdit: "Importieren oder Bearbeiten",
    originalArticle: "Originalartikel",
    preview: "Artikelvorschau",
    links: "Artikel-Links",
    share: "Teilen",
    feed: "Partner Feed",
    partner: "Partner"
  },
  assemblerEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    backButton: "Zurück zur Assembler-Liste",
    editAssembler: "Assembler bearbeiten",
    messageSaved: "Neues Assembler gespeichert"
  },
  assemblerTransformer: {
    inlineImageMissingCredit: "Ein oder mehrere Inline-Bilder wurden aufgrund fehlender Bild-Credits im Feed entfernt.",
    mainImageMissingCredit: "Das Teaserbild des Artikels wurde entfernt, da der Feed kein Bild-Credit enthält.",
    inlineImageUploadError: "Ein oder mehrere Inline-Bilder konnten aufgrund eines Fehlers nicht hochgeladen werden.",
    mainImageUploadError: "Das Hauptartikelbild konnte aufgrund eines Fehlers nicht hochgeladen werden.",
    ctaButtonMissing: "Eine oder mehrere CTA-Button wurden entfernt, da sie in Vibe fehlen.",
    mainImageUpscaled: "Das Hauptbild wurde aufgrund der niedrigen Auflösung hochskaliert. Bitte überprüfen Sie die Bildqualität.",
    mainImageUpscaleError: "Wir haben versucht, das Hauptbild zu vergrößern, aber es ist nicht gelungen – das Bild wurde in der Originalauflösung hochgeladen."
  },
  assemblerSorting: {
    sort: "Sortieren",
    createDate: "Datum des Imports",
    publishDate: "Datum der Veröffentlichung"
  },
  assemblerNewPartnerArticle: {
    newPartnerArticle: "Neuer Partnerartikel",
    missingPartnerId: "Ausgewählte Partner-ID fehlt",
    manualCreate: "Erstellen"
  },
  assemblerKim: {
    transform: "KIM-Transformation",
    prompt: "Prompt",
    promptStart: "Prompter Start (behoben)",
    processFormat: "Artikel verarbeiten im Format",
    html: "HTML",
    markdown: "Markdown",
    checkResult: "Überprüfe das Ergebnis",
    original: "Original",
    kimOutput: "KIM-Ausgang",
    startAgain: "Neu starten",
    loadingMessage: "Artikel wird an KIM gesendet. Bitte warten, das kann eine Weile dauern ...",
    promptNotFound: "Der angeforderte Prompt wurde nicht gefunden",
    fetchPromptsError: "Abrufen der Eingaben von KIM fehlgeschlagen",
    fetchPromptsNoDataInfo: "Es wurden keine Prompts empfangen. Aktionen sind derzeit deaktiviert, aber Sie können immer noch Ihre eigene Eingabeaufforderung eingeben",
    refetchPrompts: "Aufforderungen zum Zurückholen",
    brand: "Brand",
    actionType: {
      label: "Aktionstyp",
      rephrase: "Umformulieren",
      translate: "Übersetzen",
      seo: "SEO"
    }
  },
  assemblerPreview: {
    missingCredits: "Fehlende Bildnachweise",
    missingCaption: "Fehlende Bildunterschrift",
    ctaButtonLoading: "CTA-Button wird geladen…",
    ctaButtonLoadingFailed: "Laden der CTA-Button fehlgeschlagen!",
    imageImportTooltip: "Image importieren",
    imageImportError: "Bild kann nicht geholt werden"
  },
  assemblerLinks: {
    articleId: "Artikel-ID",
    originalArticleUrl: "URL des Originalartikels",
    previewUrl: "Artikelvorschau-URL",
    copyToClipboardSuccess: "Erfolgreich in die Zwischenablage kopiert.",
    copyToClipboardError: "Fehler beim Kopieren in die Zwischenablage. Bitte kopieren Sie den Wert manuell.",
    bunteLiveURL: "Bunte Live Artikel",
    chipLiveURL: "Chip Live Artikel",
    focusLiveURL: "Focus Live Artikel"
  },
  feedly: {
    feed: "Feed",
    feeds: "Feeds",
    category: "Kategorie",
    categories: "Kategorien",
    filter: "Filter"
  },
  assemblerContentSource: {
    label: "Quelle",
    all: "Alle",
    partner: "Partner",
    other: "Agenturen, Interne Brands, Sonderpartner"
  },
  assemblerContentType: {
    label: "Typ",
    all: "Alle",
    content: "Artikel",
    image: "Bilder"
  },
  articleTags: {
    ["breaking-news"]: "Eilmeldung",
    ["urgency-1"]: "Dringlichkeit 1",
    ["urgency-2"]: "Dringlichkeit 2",
    ["urgency-3"]: "Dringlichkeit 3",
    ["urgency-4"]: "Dringlichkeit 4",
    ["urgency-5"]: "Dringlichkeit 5",
    ["urgency-6"]: "Dringlichkeit 6"
  }
};
const en = {
  assemblerApi: {
    createAlreadyExists: "Can't create Assembler because another Assembler with this name already exists",
    updateAlreadyExists: "Can't update Assembler because another Assembler with this name already exists",
    created: "Assembler created",
    updated: "Assembler updated",
    notFound: "Assembler not found",
    requiredFields: "You can't save the Assembler because mandatory information is missing"
  },
  assemblerList: {
    title: "Partner Content",
    newButton: "New Assembler",
    searchLabel: "Search by title or lead text",
    deleteAssembler: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Assembler",
    headerTeaser: "Teaser",
    headerSummary: "Article Summary",
    headerBrands: "Brands",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Assembler counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createAssembler: "Create Assembler",
    partner: "Partner",
    partnerMissing: "Partner missing",
    partnerExpired: "Expired",
    fixum: "Fixum",
    revShare: "Revenue Share",
    layout: {
      table: "Table",
      grid: "Grid",
      list: "List"
    },
    automaticPollingOn: "We are checking for new articles automatically every {interval} seconds. Tap here to check for new articles immediately.",
    automaticPollingOff: "We are not checking for new articles right now. Tap here to turn it on.",
    newBreakingNewsArticle: "A new breaking-news article has arrived!",
    openPreview: "Open article preview",
    visibilitySettings: {
      actions: "Actions",
      brands: "Brands",
      categories: "Categories",
      date: "Dates",
      partner: "Partner",
      leadtext: "Lead text",
      tags: "Tags (breaking news, urgency etc.)",
      teaser: "Teaser image"
    }
  },
  assembler: {
    assemblerLabel: "Assembler",
    backButton: "Back to Assembler list",
    newAssembler: "New Assembler",
    messageDeleteAssembler: "Delete Assembler",
    messageDeleteAssemblerTitle: "Are you sure you want to delete this Assembler?",
    deleteAssembler: "Delete",
    messageDeleted: "Assembler Deleted",
    errorOnDeleting: "There was an error deleting the Assembler ",
    errorFailedLoadedAssemblerWithId: "There was an error getting the Assembler",
    dropdownEdit: "Edit article",
    dropdownImport: "Import article",
    dropdownImportEdit: "Import or Edit",
    originalArticle: "Original article",
    preview: "Article preview",
    links: "Article links",
    share: "Share",
    feed: "Partner Feed",
    partner: "Partner"
  },
  assemblerEdit: {
    label: "Label",
    counter: "Counter",
    backButton: "Back to Assembler list",
    editAssembler: "Edit Assembler",
    messageSaved: "New Assembler saved"
  },
  assemblerTransformer: {
    inlineImageMissingCredit: "One or more inline images were removed because of missing image credit in the feed.",
    mainImageMissingCredit: "The main article image was removed because there is no image credit in the feed.",
    inlineImageUploadError: "One or more inline images could not be uploaded due to an error.",
    mainImageUploadError: "The main article image could not be uploaded due to an error.",
    ctaButtonMissing: "One or more CTA buttons were removed because they are missing in Vibe.",
    mainImageUpscaled: "Main image has been upscaled due to low resolution. Please check the quality of the image.",
    mainImageUpscaleError: "We tried to upscale the main image, but failed - image was uploaded in original resolution."
  },
  assemblerSorting: {
    sort: "Sort",
    createDate: "Import Date",
    publishDate: "Publish Date"
  },
  assemblerNewPartnerArticle: {
    newPartnerArticle: "New partner article",
    missingPartnerId: "Selected partner ID is missing",
    manualCreate: "Create"
  },
  assemblerKim: {
    transform: "KIM Transform",
    prompt: "Prompt",
    promptStart: "Prompt start (fixed)",
    processFormat: "Process article in format",
    html: "HTML",
    markdown: "Markdown",
    checkResult: "Check result",
    original: "Original",
    kimOutput: "KIM Output",
    startAgain: "Start again",
    loadingMessage: "Sending article to KIM. Hang on, this might take a while...",
    promptNotFound: "Failed to find requested prompt",
    fetchPromptsError: "Failed to get prompts from KIM",
    fetchPromptsNoDataInfo: "No prompts were received. Actions are currently disabled, but you can still enter your own prompt",
    refetchPrompts: "Refetch prompts",
    brand: "Brand",
    actionType: {
      label: "Action type",
      rephrase: "Rephrase",
      translate: "Translate",
      seo: "SEO"
    }
  },
  assemblerPreview: {
    missingCredits: "Missing image credits",
    missingCaption: "Missing image caption",
    ctaButtonLoading: "Loading CTA button...",
    ctaButtonLoadingFailed: "CTA button loading failed!",
    imageImportTooltip: "Import image",
    imageImportError: "Failed to fetch image"
  },
  assemblerLinks: {
    articleId: "Article ID",
    originalArticleUrl: "Original article URL",
    previewUrl: "Article preview URL",
    copyToClipboardSuccess: "Successfully copied to clipboard.",
    copyToClipboardError: "Error copying to clipboard - please copy the value manually.",
    bunteLiveURL: "Bunte Live Article",
    chipLiveURL: "Chip Live Article",
    focusLiveURL: "Focus Live Article"
  },
  feedly: {
    feed: "Feed",
    feeds: "Feeds",
    category: "Category",
    categories: "Categories",
    filter: "Filter"
  },
  assemblerContentSource: {
    label: "Source",
    all: "All",
    partner: "Partner",
    other: "Agencies, Internal Brands, Special Partners"
  },
  assemblerContentType: {
    label: "Type",
    all: "All",
    content: "Article",
    image: "Image"
  },
  articleTags: {
    ["breaking-news"]: "Breaking news",
    ["urgency-1"]: "Urgency 1",
    ["urgency-2"]: "Urgency 2",
    ["urgency-3"]: "Urgency 3",
    ["urgency-4"]: "Urgency 4",
    ["urgency-5"]: "Urgency 5",
    ["urgency-6"]: "Urgency 6"
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.assembler.path}`,
    meta: { i18RouteTitleKey: ROUTES.assembler.path },
    children: [
      {
        path: "",
        name: "assembler_list",
        component: () => import("./assembler-list.view-DYC-bSNj.js"),
        meta: { requiredRight: "navigate_list_assemblers" }
      },
      {
        path: ":id",
        name: "assembler_detail",
        component: () => import("./assembler-detail.view-Crwwvvgy.js"),
        props: (route) => ({ id: route.params.id, backRoute: "/assembler" }),
        meta: { requiredRight: "navigate_assembler" }
      }
    ]
  }
];
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "assembler-preview.cta-button",
  props: {
    ctaButtonBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const { t } = useI18n();
    const getInitialCtaButton = () => ({
      ...getEmptyCtaButton(),
      label: t("assemblerPreview.ctaButtonLoading")
    });
    const ctaButtonData = ref(getInitialCtaButton());
    const ctaButtonImageSource = ref();
    const loadFailed = ref(false);
    const updateCtaButton = async () => {
      ctaButtonData.value = getInitialCtaButton();
      loadFailed.value = false;
      if (props.ctaButtonBlock) {
        try {
          ctaButtonData.value = await getCtaButton(props.ctaButtonBlock.ctaButtonUuid);
          if (ctaButtonData.value.imageUuid) {
            const ctaButtonImageData = await getImage(ctaButtonData.value.imageUuid);
            ctaButtonImageSource.value = getImageUrl(
              ctaButtonImageData.image._id,
              ctaButtonImageData.image.width,
              ctaButtonImageData.image.height
            );
          }
        } catch (e) {
          loadFailed.value = true;
          ctaButtonData.value = {
            ...ctaButtonData.value,
            label: t("assemblerPreview.ctaButtonLoadingFailed")
          };
        }
      }
    };
    onBeforeMount(updateCtaButton);
    watch(
      () => props.ctaButtonBlock,
      (newBlock) => newBlock.ctaButtonUuid !== ctaButtonData.value._id && updateCtaButton()
    );
    const ctaButtonColor = computed(() => {
      if (loadFailed.value)
        return "negative";
      return ctaButtonData.value.layoutType === "primary" ? "black" : "orange-9";
    });
    const __returned__ = { props, t, getInitialCtaButton, ctaButtonData, ctaButtonImageSource, loadFailed, updateCtaButton, ctaButtonColor, get QBtn() {
      return QBtn;
    }, get QImg() {
      return QImg;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$9 = { class: "assembler-preview-cta-button-wrapper" };
const _hoisted_2$8 = {
  key: 0,
  class: "assembler-preview-cta-button-image-wrapper"
};
const _hoisted_3$6 = { class: "row justify-center q-pb-md" };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    $setup.ctaButtonImageSource ? (openBlock(), createElementBlock("div", _hoisted_2$8, [
      createVNode($setup["QImg"], {
        class: "full-width full-height",
        src: $setup.ctaButtonImageSource
      }, null, 8, ["src"])
    ])) : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_3$6, [
      createVNode($setup["QBtn"], {
        label: $setup.ctaButtonData.label,
        color: $setup.ctaButtonColor,
        href: $setup.ctaButtonData.link,
        target: "_blank",
        "icon-right": $setup.loadFailed ? "warning" : "chevron-right",
        class: normalizeClass({ "cta-button": $setup.ctaButtonImageSource })
      }, null, 8, ["label", "color", "href", "icon-right", "class"])
    ])
  ]);
}
const AssemblerPreviewCtaButton = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__scopeId", "data-v-b421d498"], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-preview.cta-button.vue"]]);
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "assembler-image-import.button",
  props: {
    imageBlock: { type: Object, required: true },
    articleTitle: { type: String, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const router = useRouter();
    const notificationStore = useNotificationStore();
    const props = __props;
    const handleImportImage = async () => {
      await fetch(props.imageBlock.source).then(async (response) => {
        const blob = await response.blob();
        const contentType = response.headers.get("Content-Type") || "image/jpeg";
        const extension = contentType.split("/")[1] || "jpg";
        const file = new File([blob], `${"importImage"}.${extension}`, { type: contentType });
        const { source, title, alt, caption, credits, height, width } = props.imageBlock;
        prefillEditorImage(
          {
            source,
            title: title || caption || props.articleTitle,
            alt,
            caption,
            credits,
            height,
            width
          },
          file
        );
        router.push({ name: "image_new" });
      }).catch(() => notificationStore.showNotification(new CMSNotification(t("assemblerPreview.imageImportError"))));
    };
    const __returned__ = { t, router, notificationStore, props, handleImportImage, get QBtn() {
      return QBtn;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QBtn"], {
    icon: "download",
    round: "",
    dense: "",
    flat: "",
    color: "white",
    class: "absolute-top-right q-ma-sm bg-primary",
    onClick: $setup.handleImportImage
  }, {
    default: withCtx(() => [
      createVNode($setup["QTooltip"], {
        anchor: "top middle",
        self: "bottom middle"
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString($setup.t("assemblerPreview.imageImportTooltip")),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })
    ]),
    _: 1
    /* STABLE */
  });
}
const AssemblerImageImportButton = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-image-import.button.vue"]]);
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "assembler-preview.image",
  props: {
    imageBlock: { type: Object, required: true },
    articleTitle: { type: String, required: true },
    isKimPreview: { type: Boolean, required: false, default: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const __returned__ = { t, get QImg() {
      return QImg;
    }, AssemblerImageImportButton };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$8 = {
  class: "ca-preview-image-wrapper",
  style: { "position": "relative" }
};
const _hoisted_2$7 = { class: "row q-gutter-x-sm justify-center items-center full-width" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    createVNode($setup["QImg"], {
      src: $props.imageBlock.source
    }, null, 8, ["src"]),
    $props.imageBlock.isImportableInVibe && !$props.isKimPreview ? (openBlock(), createBlock($setup["AssemblerImageImportButton"], {
      key: 0,
      "image-block": $props.imageBlock,
      "article-title": $props.articleTitle
    }, null, 8, ["image-block", "article-title"])) : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_2$7, [
      createElementVNode(
        "div",
        {
          class: normalizeClass(["ca-preview-image-caption text-caption text-center q-pt-xs", { "text-red": !$props.imageBlock.caption }])
        },
        toDisplayString($props.imageBlock.caption || $setup.t("assemblerPreview.missingCaption")),
        3
        /* TEXT, CLASS */
      ),
      createElementVNode(
        "div",
        {
          class: normalizeClass(["ca-preview-image-credits text-caption text-center q-pt-xs", { "text-red": !$props.imageBlock.credits }])
        },
        toDisplayString($props.imageBlock.credits || $setup.t("assemblerPreview.missingCredits")),
        3
        /* TEXT, CLASS */
      )
    ])
  ]);
}
const assemblerPreviewImage = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-preview.image.vue"]]);
function loadSocialWidgetScript(widgetScriptId, widgetSrc, crossOrigin) {
  const scriptElem = document.createElement("script");
  scriptElem.id = widgetScriptId;
  scriptElem.src = widgetSrc;
  scriptElem.defer = true;
  document.body.appendChild(scriptElem);
}
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "facebook-social.block",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    onBeforeMount(() => {
      if (window.FB) {
        window.FB.XFBML.parse();
      } else {
        delete window.FB;
        loadSocialWidgetScript("facebook_script", "//connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v7.0");
      }
    });
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$7 = { class: "facebook-post-container" };
const _hoisted_2$6 = ["data-href"];
const _hoisted_3$5 = ["data-href"];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    _cache[0] || (_cache[0] = createElementVNode(
      "div",
      { id: "fb-root" },
      null,
      -1
      /* CACHED */
    )),
    $props.socialBlock.embedType === "posts" ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "fb-post",
      "data-href": $props.socialBlock.postUrl
    }, null, 8, _hoisted_2$6)) : createCommentVNode("v-if", true),
    $props.socialBlock.embedType === "videos" ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "fb-video",
      "data-href": $props.socialBlock.postUrl,
      "data-width": "500",
      "data-show-text": "false",
      "data-allowfullscreen": "true",
      "data-autoplay": "false",
      "data-show-captions": "true"
    }, null, 8, _hoisted_3$5)) : createCommentVNode("v-if", true)
  ]);
}
const FacebookSocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/social-blocks/facebook-social.block.vue"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "instagram-social.block",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const postUrl = `https://www.instagram.com/p/${props.socialBlock.postId}/?utm_source=ig_embed&amp;utm_campaign=loading`;
    onBeforeMount(() => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      } else {
        loadSocialWidgetScript("instagram_script", "//www.instagram.com/embed.js");
      }
    });
    const __returned__ = { props, postUrl };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$6 = { class: "instagram-post-container row justify-center q-pa-sm" };
const _hoisted_2$5 = { class: "q-pa-md" };
const _hoisted_3$4 = { class: "q-my-md flex justify-center items-center" };
const _hoisted_4 = {
  class: "instagram-icon",
  viewBox: "0 0 60 60",
  xmlns: "http://www.w3.org/2000/svg",
  style: { "height": "50px", "width": "50px" }
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("blockquote", {
      class: "instagram-media q-pa-none q-border-radius-md shadow-2",
      "data-instgrm-permalink": $setup.postUrl,
      "data-instgrm-version": "14"
    }, [
      createElementVNode("div", _hoisted_2$5, [
        createElementVNode("a", {
          href: $setup.postUrl,
          class: "instagram-link text-center",
          target: "_blank"
        }, [
          _cache[1] || (_cache[1] = createStaticVNode('<div class="q-gutter-sm flex items-center" data-v-151c61bc><div class="bg-grey-3 rounded-full" style="height:40px;width:40px;" data-v-151c61bc></div><div class="q-gutter-xs" data-v-151c61bc><div class="bg-grey-3 rounded-sm" style="height:14px;width:100px;" data-v-151c61bc></div><div class="bg-grey-3 rounded-sm" style="height:14px;width:60px;" data-v-151c61bc></div></div></div><div class="q-mt-md" style="padding-top:19%;" data-v-151c61bc></div>', 2)),
          createElementVNode("div", _hoisted_3$4, [
            (openBlock(), createElementBlock("svg", _hoisted_4, _cache[0] || (_cache[0] = [
              createElementVNode(
                "g",
                {
                  stroke: "none",
                  fill: "none",
                  "fill-rule": "evenodd"
                },
                [
                  createElementVNode("g", {
                    transform: "translate(-511.000000, -20.000000)",
                    fill: "#000000"
                  }, [
                    createElementVNode("g", null, [
                      createElementVNode("path", { d: "M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631" })
                    ])
                  ])
                ],
                -1
                /* CACHED */
              )
            ])))
          ]),
          _cache[2] || (_cache[2] = createStaticVNode('<div class="q-my-sm text-primary text-caption text-bold" data-v-151c61bc>View this post on Instagram</div><div class="q-mt-md" data-v-151c61bc><div class="q-gutter-sm flex items-center" data-v-151c61bc><div class="bg-grey-3 rounded-full" style="height:12.5px;width:12.5px;" data-v-151c61bc></div><div class="bg-grey-3 rounded-full" style="height:12.5px;width:12.5px;transform:translateX(9px) translateY(-18px);" data-v-151c61bc></div></div></div><div class="q-mt-lg q-gutter-sm" data-v-151c61bc><div class="bg-grey-3 rounded-sm" style="height:14px;width:224px;" data-v-151c61bc></div><div class="bg-grey-3 rounded-sm" style="height:14px;width:144px;" data-v-151c61bc></div></div>', 3))
        ])
      ])
    ])
  ]);
}
const InstagramSocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-151c61bc"], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/social-blocks/instagram-social.block.vue"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "tiktok-social.block",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    onBeforeMount(() => {
      loadSocialWidgetScript("tikTok_script", "//www.tiktok.com/embed.js");
    });
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$5 = { class: "tiktok-post-container" };
const _hoisted_2$4 = ["cite", "data-video-id"];
const _hoisted_3$3 = ["cite", "data-unique-id"];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    $props.socialBlock.embedType === "video" ? (openBlock(), createElementBlock("blockquote", {
      key: 0,
      class: "tiktok-embed",
      cite: $props.socialBlock.postUrl,
      "data-video-id": $props.socialBlock.postId,
      style: { "max-width": "605px", "min-width": "325px" }
    }, _cache[0] || (_cache[0] = [
      createElementVNode(
        "section",
        null,
        null,
        -1
        /* CACHED */
      )
    ]), 8, _hoisted_2$4)) : createCommentVNode("v-if", true),
    $props.socialBlock.embedType === "photo" ? (openBlock(), createElementBlock("blockquote", {
      key: 1,
      class: "tiktok-embed",
      cite: $props.socialBlock.postUrl,
      "data-unique-id": $props.socialBlock.accountName,
      "data-embed-type": "creator",
      style: { "max-width": "780px", "min-width": "288px" }
    }, _cache[1] || (_cache[1] = [
      createElementVNode(
        "section",
        null,
        null,
        -1
        /* CACHED */
      )
    ]), 8, _hoisted_3$3)) : createCommentVNode("v-if", true)
  ]);
}
const TiktokSocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/social-blocks/tiktok-social.block.vue"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "twitter-social.block",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    onBeforeMount(() => {
      if (window.twttr) {
        return window.twttr.widgets.load();
      } else {
        loadSocialWidgetScript("twitter_script", "https://platform.twitter.com/widgets.js");
      }
    });
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$4 = { class: "twitter-post-container" };
const _hoisted_2$3 = { class: "twitter-tweet" };
const _hoisted_3$2 = ["href"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("blockquote", _hoisted_2$3, [
      createElementVNode("a", {
        href: `https://twitter.com/${$props.socialBlock.accountName}/status/${$props.socialBlock.postId}`
      }, null, 8, _hoisted_3$2)
    ])
  ]);
}
const TwitterSocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/social-blocks/twitter-social.block.vue"]]);
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "youtube-social.block",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$3 = { class: "youtube-video-container" };
const _hoisted_2$2 = ["cite", "data-video-id", "data-short-id"];
const _hoisted_3$1 = ["src"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("blockquote", {
      class: normalizeClass($props.socialBlock.embedType === "video" ? "youtube-video" : "youtube-shorts"),
      cite: $props.socialBlock.postUrl,
      "data-video-id": $props.socialBlock.embedType === "video" ? $props.socialBlock.postId : void 0,
      "data-short-id": $props.socialBlock.embedType === "short" ? $props.socialBlock.postId : void 0
    }, [
      createElementVNode("iframe", {
        src: `https://www.youtube.com/embed/${$props.socialBlock.postId}?feature=oembed`,
        style: { "width": "100%", "height": "100%" },
        frameborder: "0",
        referrerpolicy: "strict-origin-when-cross-origin",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowfullscreen: ""
      }, null, 8, _hoisted_3$1)
    ], 10, _hoisted_2$2)
  ]);
}
const YoutubeSocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-934a7cb6"], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/social-blocks/youtube-social.block.vue"]]);
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "assembler-preview.social",
  props: {
    socialBlock: { type: Object, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { getSocialName, SocialMediaPlatforms } = SocialLinkUtils;
    const __returned__ = { getSocialName, SocialMediaPlatforms, FacebookSocialBlock, InstagramSocialBlock, TiktokSocialBlock, TwitterSocialBlock, YoutubeSocialBlock };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$2 = { class: "ca-preview-social-wrapper" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    $setup.getSocialName($props.socialBlock.content) === $setup.SocialMediaPlatforms.Youtube ? (openBlock(), createBlock($setup["YoutubeSocialBlock"], {
      key: $props.socialBlock.postId,
      "social-block": $props.socialBlock
    }, null, 8, ["social-block"])) : createCommentVNode("v-if", true),
    $setup.getSocialName($props.socialBlock.content) === $setup.SocialMediaPlatforms.Instagram ? (openBlock(), createBlock($setup["InstagramSocialBlock"], {
      key: $props.socialBlock.postId,
      "social-block": $props.socialBlock
    }, null, 8, ["social-block"])) : createCommentVNode("v-if", true),
    $setup.getSocialName($props.socialBlock.content) === $setup.SocialMediaPlatforms.Twitter ? (openBlock(), createBlock($setup["TwitterSocialBlock"], {
      key: $props.socialBlock.postId,
      "social-block": $props.socialBlock
    }, null, 8, ["social-block"])) : createCommentVNode("v-if", true),
    $setup.getSocialName($props.socialBlock.content) === $setup.SocialMediaPlatforms.TikTok ? (openBlock(), createBlock($setup["TiktokSocialBlock"], {
      key: $props.socialBlock.postId,
      "social-block": $props.socialBlock
    }, null, 8, ["social-block"])) : createCommentVNode("v-if", true),
    $setup.getSocialName($props.socialBlock.content) === $setup.SocialMediaPlatforms.Facebook ? (openBlock(), createBlock($setup["FacebookSocialBlock"], {
      key: $props.socialBlock.postId,
      "social-block": $props.socialBlock
    }, null, 8, ["social-block"])) : createCommentVNode("v-if", true)
  ]);
}
const AssemblerPreviewSocial = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-preview.social.vue"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "assembler-preview.body",
  props: {
    assemblerDoc: { type: Object, required: true },
    isKimPreview: { type: Boolean, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const isImageDisplayed = (image, itemIndex) => {
      var _a, _b;
      if (image.source === ((_b = (_a = props.assemblerDoc) == null ? void 0 : _a.mainImage) == null ? void 0 : _b.source) && itemIndex === 0)
        return false;
      return true;
    };
    const __returned__ = { props, isImageDisplayed, AssemblerPreviewCtaButton, AssemblerPreviewImage: assemblerPreviewImage, AssemblerPreviewSocial };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = {
  "data-qa-assembler-preview-body": "",
  class: "ca-article-preview-body"
};
const _hoisted_2$1 = ["innerHTML"];
const _hoisted_3 = {
  key: 3,
  class: "q-pb-md"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList($props.assemblerDoc.content, (item, index) => {
        return openBlock(), createElementBlock(
          Fragment,
          {
            key: `content-item-${index}`
          },
          [
            createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
            item.type === "TEXT" || item.type === "PARTNER" ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "q-pb-md",
              innerHTML: item.content
            }, null, 8, _hoisted_2$1)) : item.type === "IMAGE" && $setup.isImageDisplayed(item, index) ? (openBlock(), createBlock($setup["AssemblerPreviewImage"], {
              key: 1,
              class: "q-pb-sm",
              "image-block": item,
              "is-kim-preview": $props.isKimPreview,
              "article-title": $props.assemblerDoc.title
            }, null, 8, ["image-block", "is-kim-preview", "article-title"])) : item.type === "SOCIAL" ? (openBlock(), createBlock($setup["AssemblerPreviewSocial"], {
              key: item.postId,
              class: "q-pb-md",
              "social-block": item
            }, null, 8, ["social-block"])) : item.type === "QUOTE" ? (openBlock(), createElementBlock(
              "blockquote",
              _hoisted_3,
              toDisplayString(item.quote),
              1
              /* TEXT */
            )) : item.type === "CTA_BUTTON" ? (openBlock(), createBlock($setup["AssemblerPreviewCtaButton"], {
              key: 4,
              "cta-button-block": item
            }, null, 8, ["cta-button-block"])) : createCommentVNode("v-if", true)
          ],
          64
          /* STABLE_FRAGMENT */
        );
      }),
      128
      /* KEYED_FRAGMENT */
    ))
  ]);
}
const AssemblerPreviewBody = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-preview.body.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "assembler-preview-body.container",
  props: {
    assemblerDoc: { type: Object, required: true },
    showPubDate: { type: Boolean, required: false },
    isKimPreview: { type: Boolean, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get formatDateDots() {
      return formatDateDots;
    }, get QPage() {
      return QPage;
    }, get QPageContainer() {
      return QPageContainer;
    }, AssemblerPreviewBody, assemblerPreviewImage };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = {
  key: 1,
  class: "text-caption q-pb-sm q-pt-xs"
};
const _hoisted_2 = { class: "ca-article-preview-lead-text text-primary text-bold q-pb-md" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QPageContainer"], { "data-qa-assembler-preview-body-container": "" }, {
    default: withCtx(() => [
      createVNode($setup["QPage"], { class: "text-black bg-white q-layout-padding q-py-sm" }, {
        default: withCtx(() => {
          var _a;
          return [
            createElementVNode("div", null, [
              ((_a = $props.assemblerDoc) == null ? void 0 : _a.mainImage) ? (openBlock(), createBlock($setup["assemblerPreviewImage"], {
                key: 0,
                class: normalizeClass({ "q-mb-md": !($props.showPubDate && $props.assemblerDoc.publishDate) }),
                "image-block": $props.assemblerDoc.mainImage,
                "is-kim-preview": $props.isKimPreview,
                "article-title": $props.assemblerDoc.title
              }, null, 8, ["class", "image-block", "is-kim-preview", "article-title"])) : createCommentVNode("v-if", true),
              $props.showPubDate && $props.assemblerDoc.publishDate ? (openBlock(), createElementBlock(
                "div",
                _hoisted_1,
                toDisplayString($setup.formatDateDots($props.assemblerDoc.publishDate)),
                1
                /* TEXT */
              )) : createCommentVNode("v-if", true),
              renderSlot(_ctx.$slots, "preview-body", {}, () => [
                createElementVNode("div", _hoisted_2, [
                  createElementVNode(
                    "p",
                    null,
                    toDisplayString($props.assemblerDoc.leadText),
                    1
                    /* TEXT */
                  )
                ]),
                createVNode($setup["AssemblerPreviewBody"], { "assembler-doc": $props.assemblerDoc }, null, 8, ["assembler-doc"])
              ])
            ])
          ];
        }),
        _: 3
        /* FORWARDED */
      })
    ]),
    _: 3
    /* FORWARDED */
  });
}
const AssemblerPreviewBodyContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/assembler/editor-ui/src/components/preview/assembler-preview-body.container.vue"]]);
const AssemblerFetchEventModelName = "AssemblerFetchEvent";
const AssemblerFetchEventService = registerEntityEndpoint(
  AssemblerFetchEventModelName,
  "/cms/assembler/fetch-events"
);
const { listEntities } = AssemblerFetchEventService;
const getAssemblerFetchEventList = async (params = {}) => listEntities(params);
const getEmptyAssemblerFetchEvent = () => ({
  _id: "ac2d7973-c662-4266-8f90-ff164dd31e25",
  feedUuid: "71b6a392-798f-462c-8fd6-61b8ec5372cf",
  isProcessing: false,
  result: "success",
  startDate: /* @__PURE__ */ new Date()
});
const assemblerModule = {
  messages,
  routes
};
export {
  AssemblerPreviewBodyContainer as A,
  _export_sfc as _,
  AssemblerPreviewBody as a,
  assemblerModule as b,
  AssemblerFetchEventModelName as c,
  AssemblerFetchEventService as d,
  getEmptyAssemblerFetchEvent as e,
  getAssemblerFetchEventList as g
};
//# sourceMappingURL=index-CdcXfFUA.js.map
